import { apiClient } from '@/utils/api-client';
import type { ApiResponse, JsonApiResource } from '@/types/api';

export interface AgentConfig {
  id: string;
  key: string;
  published_value: unknown;
  pending_value: unknown | null;
  published_at: string | null;
  category: string;
  value_type: 'string' | 'number' | 'boolean' | 'select';
  label: string;
  description: string | null;
  default_value: unknown;
  validation_rules: {
    min?: number;
    max?: number;
    options?: string[];
  } | null;
  /** Key of a boolean config this setting only takes effect under */
  depends_on: string | null;
  has_pending_changes: boolean;
  created_at: string;
  updated_at: string;
}

export const agentConfigService = {
  async list(params?: { category?: string }): Promise<ApiResponse<JsonApiResource<AgentConfig>[]>> {
    const queryParams: Record<string, string> = {};
    if (params?.category) queryParams.category = params.category;
    return apiClient.get('/api/admin/agent_configs', queryParams);
  },

  async get(id: string): Promise<ApiResponse<JsonApiResource<AgentConfig>>> {
    return apiClient.get(`/api/admin/agent_configs/${id}`);
  },

  async update(id: string, pendingValue: unknown): Promise<ApiResponse<JsonApiResource<AgentConfig>>> {
    return apiClient.patch(`/api/admin/agent_configs/${id}`, {
      agent_config: { pending_value: pendingValue },
    });
  },

  async publish(id: string): Promise<ApiResponse<JsonApiResource<AgentConfig>>> {
    return apiClient.post(`/api/admin/agent_configs/${id}/publish`);
  },

  async discard(id: string): Promise<ApiResponse<JsonApiResource<AgentConfig>>> {
    return apiClient.post(`/api/admin/agent_configs/${id}/discard`);
  },

  async publishAll(): Promise<ApiResponse<JsonApiResource<AgentConfig>[]>> {
    return apiClient.post('/api/admin/agent_configs/publish_all');
  },

  async resetToDefault(id: string): Promise<ApiResponse<JsonApiResource<AgentConfig>>> {
    return apiClient.post(`/api/admin/agent_configs/${id}/reset_to_default`);
  },
};
